/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum YesNo {
  Yes = "Yes",
  No = "No",
}

export const YesNoDisplay: Record<YesNo, string> = {
  [YesNo.Yes]: "Yes",
  [YesNo.No]: "No",
};
